export const MOBILE_MAX = 767;
export const TABLET_MAX = 1199;
